import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { CommonService } from '../../../api/services/common.service';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { FormsServiceService } from '../../../api/services/forms-service.service';

@Component({
  selector: 'app-summary-cards',
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './summary-cards.component.html',
  styleUrl: './summary-cards.component.css',
})
export class SummaryCardsComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  isLoading: boolean = false;
  endpoint = environment.api_endpoint;
  fieldsData: any[] = [];
  totalTaskCount!: number;
  constructor(
    private formService: FormsServiceService,
    private cdr: ChangeDetectorRef,
  ) {}
  ngOnInit() {
    this.getData();
  }

  /** Function to get the data by api or static */
  getData() {
    if (this.fields.options.isStatic === false) {
      this.fieldsData = this.fields.options.staticOptions;
    } else {
      const formId = this.fields.options.source.formID;
      const api_endpoint = this.endpoint;
      const method = this.fields.options.source.method;
      let url = this.fields.options.source.apiUrl;
      const replacements = {
        formID: formId,
        api_endpoint: api_endpoint,
      };
      url = this.formService.replaceTemplateTokens(url, replacements);
      const headers = {
        'Content-Type': 'application/json',
      };
      this.formService.loadData(method, url, headers).subscribe({
        next: (res: any) => {
          this.fieldsData = res.data.records;
          // ✅ Sum all taskCount values
          this.totalTaskCount = this.fieldsData.reduce(
            (sum: number, item: any) => sum + Number(item.taskCount || 0),
            0,
          );
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          this.cdr.detectChanges();
        },
      });
    }
  }
}
